export default __webpack_public_path__ + "pdf/Gesine_Müller.c700129.pdf";